// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__TrMsi","links":"Sidebar_links__3iiCY","activeLink":"Sidebar_activeLink__2pZrE","linkBack":"Sidebar_linkBack__1tCAS","heading":"Sidebar_heading__BIuiQ"};